module.exports = __webpack_public_path__ + "img/pc_flower_L.3f1e129.webp";